import axios from 'axios';
import Cookies from "js-cookie";

export const API_URL = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {

  const token = Cookies.get("hash")
  if (token) {
    config.headers['Authorization'] = `Bearer ${JSON.parse(token)}`;
  }
  return config;
});

api.interceptors.response.use((config) => {
  return config;
});

export const AUTH_CONFIG = {
  loginUrl: process.env.REACT_APP_CAS,
  logoutUrl: `${process.env.REACT_APP_CAS}/logout`,
  serviceTicketUrl: `${process.env.REACT_APP_CAS}/p3/serviceValidate`,
  autoLogon: process.env.REACT_APP_AUTO_LOGON,
};

export function SERVICE_TICKET({ service, ticket }) {
  return {
    url: `${AUTH_CONFIG.serviceTicketUrl}?service=${service}&ticket=${ticket}&format=json`,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  };
};
